// Import Cesium library
import * as Cesium from "cesium";
import React from "react";
import useViewerStore from "../stores/useViewerStore";

export default function useHQModels() {
  const { viewer } = useViewerStore();

  const models = React.useMemo(
    () => [
      "250313_HQ_A",
      "250313_HQ_B",
      "250313_HQ_C_bottom",
      "250313_HQ_C_glass",
      "250313_HQ_C_outside",
    ],
    [],
  );

  const longitude = 127.051783;
  const latitude = 37.539798;

  // 엔티티 캐시 저장용 ref
  const entityCache = React.useRef<Record<string, Cesium.Entity>>({});

  const setHQModelShow = React.useCallback(
    (show: boolean) => {
      if (!viewer) return;

      models.forEach((file) => {
        let entity = entityCache.current[file];

        if (!entity) {
          // 엔티티가 없으면 생성해서 캐시에 저장
          const position = Cesium.Cartesian3.fromDegrees(
            longitude,
            latitude,
            0.0,
          );
          const heading = Cesium.Math.toRadians(108.5);
          const pitch = Cesium.Math.toRadians(0);
          const roll = Cesium.Math.toRadians(0);
          const hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
          const orientation = Cesium.Transforms.headingPitchRollQuaternion(
            position,
            hpr,
          );

          entity = viewer.entities.add({
            id: file,
            position,
            orientation,
            model: {
              uri: `${process.env.REACT_APP_DATA_BASE_URL}/models/250313_HQ/250313_HQ/${file}/model.glb`,
              scale: 1.0,
              color: Cesium.Color.WHITE.withAlpha(0.5),
            },
            show, // show 상태 반영
          });
          entityCache.current[file] = entity;
        } else {
          // 이미 있으면 show만 토글
          entity.show = show;
        }
      });
    },
    [viewer, models, longitude, latitude],
  );

  return { setHQModelShow };
}